<template>
    <div><h1>contact</h1></div>
</template>

<script>
export default {
    
}
</script>